const leadingZero = number => {
    return number < 10 // eslint-disable-line no-magic-numbers
        ? number.toString().padStart(2, '0') // eslint-disable-line no-magic-numbers
        : number.toString();
};

const parseDate = date => {
    const year = date.getFullYear();
    const month = leadingZero(date.getMonth()+1);
    const day = leadingZero(date.getDate());
    const hours = leadingZero(date.getHours());
    const minutes = leadingZero(date.getMinutes());

    return `${year}-${month}-${day} ${hours}:${minutes}`;
};

module.exports = {
    parseDate,
    leadingZero
};



// WEBPACK FOOTER //
// /node_modules/@mands/mns-fe-pattern-library/lib/mns-fe-utilities/preview-banner/parse-date.js